//import CookieConsent from "react-cookie-consent";
import { useEffect } from "react";
import * as CookieConsent from "vanilla-cookieconsent";
import pluginConfig from "./CookieConsentConfig";
import "vanilla-cookieconsent/dist/cookieconsent.css";
import "./cookie-banner.css";

export const CookieConsentBanner = () => {
  useEffect(() => {
    CookieConsent.run(pluginConfig);
  }, []);

  return null;
};
